<svg:polygon
  #polygonRef
  class="svg-polygon"
  [ngClass]="theme"
  [attr.points]="polygonPoints"
  [attr.stroke-width]="SPIDER_CHART_CONFIG.polygon.strokeWidth"
  [attr.fill-opacity]="SPIDER_CHART_CONFIG.polygon.fillOpacity"
></svg:polygon>
